import {
  Box,
  CircularProgress,
  IconButton,
  TextField,
  useTheme,
} from "@mui/material";
import React, { FormEvent, RefObject, useState } from "react";
import { Send } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Container } from "@components/ChatAgent/components/ChatAgentMessageInput/style";

interface ChatAgentMessageInputProps {
  onSendMessage: (message: string) => void;
  disabled?: boolean;
  isLoading?: boolean;
  inputRef: RefObject<HTMLInputElement>;
}

const ChatAgentMessageInput = ({
  onSendMessage,
  disabled,
  isLoading,
  inputRef,
}: ChatAgentMessageInputProps) => {
  const theme = useTheme();
  const [message, setMessage] = useState("");
  const { t } = useTranslation("agent_chat");

  const sendMessage = (e?: FormEvent<HTMLFormElement>) => {
    if (e) e.preventDefault();
    if (!message) return;
    setMessage("");
    onSendMessage(message);
    if (inputRef.current) inputRef.current.focus();
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" && !e.altKey && !e.shiftKey) {
      sendMessage();
      e.preventDefault();
    }
  };

  return (
    <Container theme={theme} gap={"10px"}>
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        <form onSubmit={sendMessage}>
          <TextField
            autoFocus={true}
            disabled={disabled}
            inputRef={inputRef}
            variant={"standard"}
            placeholder={t("input_ph") || ""}
            size={"small"}
            value={message}
            sx={{ padding: 0, width: "100%" }}
            multiline={true}
            maxRows={2}
            onKeyDown={(event) => handleInputKeyDown(event)}
            onChange={(event) => setMessage(event.target.value)}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </form>
      </Box>
      <IconButton
        onClick={() => sendMessage()}
        disabled={!message || disabled || isLoading}
      >
        {isLoading ? <CircularProgress size={24} /> : <Send />}
      </IconButton>
    </Container>
  );
};

export default ChatAgentMessageInput;
